import React, { useEffect, useState } from "react";
import { userSelector } from "../../../../user-redux/selector";
import { appSelector } from "../../../../redux/selector";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";
import { Button } from "@mui/material";
import axios from "axios";
import Key from "../../../../../../src/clientVariables.json";

const SendCandidateToVendorEmail = ({
  step3EmailData,
  selectedCandidateData,
  hideToEmail = false,
}) => {
  const [htmlTemplate, setHtmlTemplate] = useState(null);
  const {
    candidates,
    selectedSubmission,
    candidateDetails,
    candidateDocuments,
    selectedJob,
    result,
  } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const emailTemplateChange = step3EmailData?.emailBody
    ? step3EmailData?.emailBody
    : `<p>
<br />If you have any further 
questions or require additional
information, please do not
hesitate to contact me. We are
eager to facilitate the next
steps in the hiring process and
would appreciate your prompt
attention to this matter.
</p>
<p><br /></p>
<p>
Thank you for considering our
candidate for the [Job Title]
position. We look forward to
hearing from you soon.<br /><br />Best
regards,
</p>
<p><br />${user?.full_name}</p>`;

  useEffect(() => {


    const fetchHtmlContent = async () => {
      try {

        const res = await axios.post(
          `${Key.domain}/candidate/get_js_profile_details`,
          {
            resume_id: selectedSubmission.resume_id,
          }
        );

        const { data } = res?.data || {};
        const selectedCandidate = data?.resumedetails || {};
        const selectedCandidateProjectDetails = data?.projectdetails || [];
        const selectedCandidateEducationDetails = data?.educationdetails || [];
        const selectedCandidateCertificationDetails = data?.certificatedetails || [];
        const selectedCandidatePersonalDetails = data?.personaldetails || {};

        const location = (selectedCandidate?.cityname ? selectedCandidate.cityname : '') +
          (selectedCandidate?.statename ? ', ' + selectedCandidate.statename : '');
        const candidateLocation = location || 'N/A';
        const vendorName = selectedSubmission?.contact_name || 'N/A';
        const candidateName = selectedCandidateData?.candidate_name || 'N/A';
        const candidatePhone = selectedCandidate?.home_phone || 'N/A';
        const candidateEmail = selectedCandidate?.email || 'N/A';
        const candidateVisaStatus = selectedCandidate?.visatype_name || 'N/A';
        const candidateLinkedin = selectedCandidate?.linkedin_url || 'N/A';
        const candidateEducation = selectedCandidateEducationDetails?.length > 0
          ? selectedCandidateEducationDetails.map(item => item?.edu_course).filter(Boolean).join('\n')
          : 'N/A';
        const candidateAvailability = 'N/A';
        const candidateInterviewAvailability = 'N/A';
        const candidateCurrentProject = selectedCandidate?.is_current_project != null
          ? (selectedCandidate.is_current_project === 0 ? 'No' : 'Yes')
          : 'N/A';
        const candidateCertifications = selectedCandidateCertificationDetails?.length > 0
          ? selectedCandidateCertificationDetails.map(item => item?.cer_name).filter(Boolean).join('\n')
          : 'N/A';
        const candidateRelocation = selectedCandidate?.willing_to_relocate != null
          ? (selectedCandidate.willing_to_relocate === 0 ? 'No' : 'Yes')
          : 'N/A';
        const candidateRate = 'N/A';
        const candidateSSN = selectedCandidatePersonalDetails?.SSN || 'N/A';
        const jobTitle = selectedCandidateData?.role || '[Job Title]';

        let content = ` <!DOCTYPE html>
          <html lang="en">
            <head>
              <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Candidate Submission</title>
                  <style>
                    body {
                      font-family: Arial, Helvetica, sans-serif;
                      line-height: 1.6;
                      color: #333333;
                      margin: 0;
                      padding: 0;
                      background-color: #f9f9f9;
                    }
                    .container {
                      max-width: 680px;
                      margin: 0 auto;
                      padding: 20px;
                      background-color: #ffffff;
                      border: 1px solid #e0e0e0;
                    }
                    .header {
                      border-bottom: 2px solid #2c5282;
                      padding-bottom: 10px;
                      margin-bottom: 20px;
                    }
                    .logo {
                      max-height: 60px;
                      margin-bottom: 10px;
                    }
                    h1 {
                      color: #2c5282;
                      margin: 0;
                      font-size: 24px;
                    }
                    .candidate-info {
                      margin-bottom: 25px;
                    }
                    .section-title {
                      font-weight: bold;
                      color: #2c5282;
                      margin-bottom: 5px;
                      font-size: 16px;
                    }
                    .info-row {
                      display: flex;
                      margin-bottom: 5px;
                    }
                    .info-label {
                      font-weight: bold;
                      width: 180px;
                      color: #4a5568;
                    }
                    .info-value {
                      flex: 1;
                    }
                    .action-button {
                      display: inline-block;
                      padding: 10px 20px;
                      background-color: #2c5282;
                      color: white;
                      text-decoration: none;
                      border-radius: 4px;
                      margin-top: 20px;
                      font-weight: bold;
                    }
                    .action-button:hover {
                      background-color: #1a365d;
                    }
                    .footer {
                      margin-top: 30px;
                      padding-top: 15px;
                      border-top: 1px solid #e0e0e0;
                      font-size: 12px;
                      color: #718096;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">
                    <div class="header">

                      <h1>Candidate Submission</h1>
                    </div>

                    ${step3EmailData?.customMode ? 
                      `<div class="candidate-info">${step3EmailData.emailBody}</div>` : 
                      `
                      <p>Dear,</p>
                      <p>I am pleased to submit our consultant for your consideration regarding the <strong>${jobTitle}</strong> position. Below are the detailed particulars of the candidate:</p>
  
                      <div class="candidate-info">
                        <div class="section-title">Candidate Details</div>
  
                        <div class="info-row">
                          <div class="info-label">Name:</div>
                          <div class="info-value">${candidateName}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Email:</div>
                          <div class="info-value">${candidateEmail}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Contact Number:</div>
                          <div class="info-value">${candidatePhone}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Location:</div>
                          <div class="info-value">${candidateLocation}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">LinkedIn Profile:</div>
                          <div class="info-value">${candidateLinkedin}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Visa Status:</div>
                          <div class="info-value">${candidateVisaStatus}</div>
                        </div>
                      </div>
  
                      <div class="candidate-info">
                        <div class="section-title">Professional Information</div>
  
                        <div class="info-row">
                          <div class="info-label">Education:</div>
                          <div class="info-value">${candidateEducation}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Certifications:</div>
                          <div class="info-value">${candidateCertifications}</div>
                        </div>
  
                        <div class="info-row">
                          <div class="info-label">Current Project Status:</div>
                          <div class="info-value">${candidateCurrentProject}</div>
                        </div>
                      </div>
  
                      <div class="candidate-info">
                        <div class="section-title">Availability Information</div>
  
                        <div class="info-row">
                          <div class="info-label">Relocation Confirmation:</div>
                          <div class="info-value">${candidateRelocation}</div>
                        </div>
                      </div>
  
                      <p>I am confident that ${candidateName}'s qualifications and experience make them an excellent fit for this role. The candidate's resume is attached for your review.</p>
                      `
                    }
  
                    <p>If you find this profile suitable, please click the button below to accept the candidate for further consideration:</p>
  
                    <div style="text-align: center;">
                      <a class="action-button" style="pointer-events: none; background-color: #a0aec0; cursor: not-allowed;">Accept Candidate</a>
                    </div>
  
                    <p>Please feel free to contact me if you need any additional information or have any questions about the candidate's profile.</p>
                    
                    ${step3EmailData?.selectedSignatureHtml ? `<div style="margin-top: 20px; border-top: 1px solid #eee; padding-top: 20px;">${step3EmailData.selectedSignatureHtml}</div>` : ""}





                    <div class="footer">
                      <p>This email contains confidential information intended only for the recipient. If you received this in error, please notify the sender and delete this email immediately.</p>
                    </div>
                  </div>
                </body>
              </html>`;

        setHtmlTemplate(content);
        setHtmlTemplate(content);
      } catch (error) {
        console.error("Error fetching HTML content:", error);
      }
    };

    fetchHtmlContent();
  }, [step3EmailData]);
  return (
    <div style={{ height: 500, width: "100%", overflow: "scroll" }}>
      {hideToEmail && (
        <p
          style={{
            margin: "0 0 12px",
            fontSize: "13px",
            color: "#616161",
            fontStyle: "italic",
          }}
        >
          Vendor recipient email will be taken from each selected job when sent.
        </p>
      )}
      {!hideToEmail && step3EmailData?.toEmail && (
        <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#333" }}>
          <strong>To:</strong> {step3EmailData.toEmail}
        </p>
      )}
      {step3EmailData?.ccEmail && (
        <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#333" }}>
          <strong>CC:</strong> {step3EmailData.ccEmail}
        </p>
      )}
      <div dangerouslySetInnerHTML={{ __html: htmlTemplate }} />
      {/* <Box sx={{ display: "flex", gap: "10px" }}>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          variant="outlined"
          size="small"
        //   onClick={() => isSubmitHandler('cancel')}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
        //   onClick={handleSubmit}
        >
          {isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Send Email"
          )}
        </Button>
      </Box> */}
    </div>
  );
};

export default SendCandidateToVendorEmail;
